/** Server compile panel on the project wiki page (EN source of truth + VI); spread into the main dictionaries */

export const wikiCompileEn = {
  'compile.title': 'Compile on the server',
  'compile.hint': 'AgentWiki reads the Sources with your AI provider, groups them into topic pages with citations, and sends the pages through review. Compiling with your own agent (`agentwiki compile`) stays free.',
  'compile.loading': 'Checking the cost…',
  'compile.loadError': 'Could not load the compile estimate.',
  'compile.sources': '{count} sources, {chars} characters',
  'compile.sources.one': '1 source, {chars} characters',
  'compile.needsEditor': 'Only editors and admins can start a server compile.',
  'compile.truncated': 'Only the newest Sources fit in one compile.',
  'compile.cost': '{credits} credits',
  'compile.balance': 'Balance: {balance} credits',
  'compile.provider': 'AI provider: {provider}',
  'compile.noProvider': 'Enable an AI provider in Settings → AI to compile on the server.',
  'compile.noSources': 'Push Sources into this project first.',
  'compile.insufficient': 'Not enough credits: this compile needs {credits}.',
  'compile.buyCredits': 'Buy credits',
  'compile.start': 'Compile for {credits} credits',
  'compile.starting': 'Starting…',
  'compile.confirm': 'Compile this project on the server for {credits} credits? Credits are refunded if no page can be written.',
  'compile.startFailed': 'Could not start the compile: {message}',
  'compile.started': 'Compile started',
  'compile.lastJob': 'Last compile',
  'compile.status.queued': 'Queued',
  'compile.status.running': 'Running: {done} of {planned} pages',
  'compile.status.planning': 'Planning topics…',
  'compile.status.succeeded': 'Done',
  'compile.status.partial': 'Done with errors',
  'compile.status.failed': 'Failed',
  'compile.charged': 'Charged {charged} of {reserved} credits',
  'compile.page.applied': 'Added',
  'compile.page.pending': 'Waiting for review',
  'compile.page.failed': 'Not written',
  'compile.review': 'Open the review queue',
}

export const wikiCompileVi: Record<keyof typeof wikiCompileEn, string> = {
  'compile.title': 'Biên soạn trên máy chủ',
  'compile.hint': 'AgentWiki đọc các Nguồn bằng nhà cung cấp AI của bạn, gom thành các trang theo chủ đề có trích dẫn, rồi gửi qua bước duyệt. Biên soạn bằng agent của bạn (`agentwiki compile`) vẫn miễn phí.',
  'compile.loading': 'Đang tính chi phí…',
  'compile.loadError': 'Không tải được ước tính chi phí.',
  'compile.sources': '{count} nguồn, {chars} ký tự',
  'compile.sources.one': '1 nguồn, {chars} ký tự',
  'compile.needsEditor': 'Chỉ vai trò Biên tập hoặc Quản trị mới bắt đầu được biên soạn trên máy chủ.',
  'compile.truncated': 'Một lần biên soạn chỉ chứa được các Nguồn mới nhất.',
  'compile.cost': '{credits} credit',
  'compile.balance': 'Số dư: {balance} credit',
  'compile.provider': 'Nhà cung cấp AI: {provider}',
  'compile.noProvider': 'Bật một nhà cung cấp AI trong Cài đặt → AI để biên soạn trên máy chủ.',
  'compile.noSources': 'Hãy đẩy Nguồn vào dự án này trước.',
  'compile.insufficient': 'Không đủ credit: lần biên soạn này cần {credits}.',
  'compile.buyCredits': 'Mua credit',
  'compile.start': 'Biên soạn với {credits} credit',
  'compile.starting': 'Đang bắt đầu…',
  'compile.confirm': 'Biên soạn dự án này trên máy chủ với {credits} credit? Credit được hoàn lại nếu không viết được trang nào.',
  'compile.startFailed': 'Không bắt đầu được: {message}',
  'compile.started': 'Đã bắt đầu biên soạn',
  'compile.lastJob': 'Lần biên soạn gần nhất',
  'compile.status.queued': 'Đang chờ',
  'compile.status.running': 'Đang chạy: {done} / {planned} trang',
  'compile.status.planning': 'Đang lập chủ đề…',
  'compile.status.succeeded': 'Xong',
  'compile.status.partial': 'Xong, có lỗi',
  'compile.status.failed': 'Thất bại',
  'compile.charged': 'Đã trừ {charged} / {reserved} credit',
  'compile.page.applied': 'Đã thêm',
  'compile.page.pending': 'Chờ duyệt',
  'compile.page.failed': 'Không viết được',
  'compile.review': 'Mở hàng chờ duyệt',
}
